/**
 * Config-gated escape hatch: "Kit in hand - no return scan". USPS refresh is 3x daily, so a kit
 * physically on the bench may not yet show a Delivered-to-lab scan (the ESTELA RAMIREZ class).
 * The tech can take it with an explicit override, which is recorded on the record and becomes a
 * chain-of-custody flag in the applied event detail.
 */
export function OverrideHatch({
  allowed,
  active,
  onToggle,
}: {
  allowed: boolean;
  active: boolean;
  onToggle: (active: boolean) => void;
}) {
  if (!allowed) {
    return (
      <p className="note">
        This kit is not yet shown as arrived, and override is disabled for this campaign.
      </p>
    );
  }
  return (
    <label className="note warn flex cursor-pointer items-start gap-3" style={{ display: 'flex' }}>
      <input
        type="checkbox"
        checked={active}
        onChange={(e) => onToggle(e.target.checked)}
        className="mt-1 h-5 w-5 shrink-0 accent-[color:var(--amber)]"
      />
      <span>
        <span className="block font-semibold" style={{ color: 'var(--amber)' }}>
          Kit in hand - no return scan
        </span>
        <span className="mt-0.5 block text-xs" style={{ color: 'var(--amber)' }}>
          Record this resulting with an override (no Delivered-to-lab scan yet). Logged as chain-of-custody.
        </span>
      </span>
    </label>
  );
}
